import { QueryCacheTimes } from 'components/flowBuilder/constants';
import { getDisclaimerText } from 'components/popups/api/disclaimer';
import { DISCLAIMER_TEXT_QUERY_KEY_PREFIX } from 'components/popups/constants';
import { useQuery } from 'react-query';

const useDisclaimerText = (shopId: number) => {
  return useQuery(
    [DISCLAIMER_TEXT_QUERY_KEY_PREFIX, shopId],
    () => getDisclaimerText(shopId),
    {
      staleTime: QueryCacheTimes.SHORT,
    },
  );
};

export default useDisclaimerText;
